import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SportsMatchFilteringWidget" */ './SportsMatchFilteringWidget'),
  modules: ['./SportsMatchFilteringWidget'],
  loading: () => <div />
});

export default LoadableWidget;
